var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "./reportBase"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, ReportBase) {
    "use strict";
    var MIN_SIZE = 3;
    var MAX_SIZE = 100;
    var DRAG_THR = 50;
    var GroupsDashboard = /** @class */ (function (_super) {
        __extends(GroupsDashboard, _super);
        function GroupsDashboard() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.desktopColumns = [];
            _this.mobileView = undefined;
            _this.grandTotalsData = ko.observable({
                TotalCalls: 0,
                MissedCalls: 0,
                AnsweredByUser: 0,
                TotalUsers: 0,
                TotalHoldDuration: 0,
                TotalCallDuration: 0
            });
            _this.chartFilterType = ko.observable(-1);
            _this.chartFilterTypeName = ko.observable("Total Calls");
            _this.chartDataByGroup = ko.observableArray();
            _this.filteredChartDataByGroup = ko.observableArray();
            _this.domainGroups = ko.observableArray();
            _this.selectedDomainGroups = ko.observableArray();
            _this.firstTimeLoad = ko.observable(true);
            _this.reinitFilterTimer = 0;
            _this.filterCdrByExtension = ko.observable("");
            _this.filterApplied = ko.observable(false);
            _this.filterInProgress = ko.observable(false);
            _this.reloadDataTimer = 0;
            _this.currentChartRange = ko.observable(0);
            //chart paging
            // Minimum/maximum number of visible items
            _this.totalExtensionRecords = 0;
            _this.viewStart = 0;
            _this.viewSize = 30;
            _this.newStart = 0;
            _this.pieViewStart = 0;
            _this.pieViewSize = 30;
            _this.pieNewStart = 0;
            return _this;
        }
        GroupsDashboard.prototype.init = function () {
            var self = this;
            $(window).off("resize.ace_hover");
            tools.ajaxGet({
                url: "/Reports/GroupsDashboardLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                        self.domainList = data.Data.lookupLists.CdrDomains;
                    }
                    self.initMain();
                    ko.applyBindings(self, document.getElementById("ko-main-content"));
                    self.initDashboard();
                    $(".loader-container").hide();
                    $("#mainContext").show();
                    self.initHistogramChart();
                    self.initHistogramSelectionChart();
                    self.initPieSelectionChart();
                    self.initPieChart();
                    self.initHistogramByTimeChart();
                    self.initLineByTimeChart();
                    self.initGrid(self.lookupLists.GridStructures.CallLogsStructure);
                    if (!self.filterCdrByDomain()) {
                        self.filterCdrByDomain(data.Data.lookupLists.DefaultDomain);
                    }
                }
            });
        };
        GroupsDashboard.prototype.initDashboard = function () {
            var self = this;
            self.filterCdrByDomain.extend({ rateLimit: 200 }).subscribe(function () {
                self.filterApplied(false);
                self.selectedDomainGroups([]);
                self.getDomainAccounts(self.filterCdrByDomain());
                self.applyFilter();
            });
            $(window).on("resize", function () {
                self.resizeChart();
            });
            $(document).on("click", ".stats-item", function (event) {
                log.log("dashboard-stats__item clicked");
                self.firstTimeLoad(false);
                if ($(event.currentTarget).hasClass("stats-item-active")) {
                    $(".stats-item").removeClass("stats-item-active");
                    self.getChartDataByGroup(-1);
                }
                else {
                    $(".stats-item").removeClass("stats-item-active");
                    $(event.currentTarget).addClass("stats-item-active");
                    self.getChartDataByGroup($(event.currentTarget).data("type"));
                }
            });
            $("#chartToggleButtons1 label").on("click", function () {
                setTimeout(function () {
                    self.updateVisibleChart1();
                });
            });
            $("#chartToggleButtons1 .zoom-chart").on("click", function () {
                var title = $("#chartToggleButtons1 .inner-title").text();
                var selectedType = $("#chartToggleButtons1 input[type='radio'][name='chartType']:checked").val();
                var chartId = "chart0";
                if (selectedType === "pie") {
                    chartId = "chart1";
                }
                else if (selectedType === "bar") {
                    chartId = "chart0";
                }
                setTimeout(function () {
                    self.zoomChart(chartId, "chartContainer1", title, function () {
                        self.resizeChart();
                    });
                });
            });
            $("#chartToggleButtons2 label").on("click", function () {
                setTimeout(function () {
                    self.updateVisibleChart2();
                });
            });
            $("#chartToggleButtons2 .zoom-chart").on("click", function () {
                var title = $("#chartToggleButtons2 .inner-title").text();
                var selectedType = $("#chartToggleButtons2 input[type='radio'][name='chartType']:checked").val();
                var chartId = "chart2";
                if (selectedType === "line") {
                    chartId = "chart3";
                }
                else if (selectedType === "bar") {
                    chartId = "chart2";
                }
                setTimeout(function () {
                    self.zoomChart(chartId, "chartContainer2", title, function () {
                        self.resizeChart();
                    });
                });
            });
        };
        GroupsDashboard.prototype.updateVisibleChart1 = function () {
            var self = this;
            var selectedType = $("#chartToggleButtons1 input[type='radio'][name='chartType']:checked").val();
            if (selectedType === "pie") {
                $("#chart0").hide();
                $("#chart1").show();
            }
            else if (selectedType === "bar") {
                $("#chart1").hide();
                $("#chart0").show();
            }
            self.resizeChart();
        };
        GroupsDashboard.prototype.updateVisibleChart2 = function () {
            var self = this;
            var selectedType = $("#chartToggleButtons2 input[type='radio'][name='chartType']:checked").val();
            if (selectedType === "line") {
                $("#chart2").hide();
                $("#chart3").show();
            }
            else if (selectedType === "bar") {
                $("#chart3").hide();
                $("#chart2").show();
            }
            self.resizeChart();
        };
        GroupsDashboard.prototype.initHistogramChart = function () {
            var self = this;
            var series = [
                {
                    type: "column",
                    field: "TotalCalls",
                    categoryField: "Extension",
                    style: "smooth",
                    name: "Group Handled Calls",
                    visible: true,
                    color: "#66bb6a",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    field: "AnsweredByUser",
                    categoryField: "Extension",
                    style: "smooth",
                    name: "Group Answered Calls",
                    visible: true,
                    color: "#29b6f6",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    field: "MissedCalls",
                    categoryField: "Extension",
                    style: "smooth",
                    name: "Missed By Groups",
                    visible: true,
                    color: "#ef5350",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    field: "TotalUsers",
                    categoryField: "Extension",
                    style: "smooth",
                    name: "Total Users",
                    visible: true,
                    color: "#ffa726",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }
            ];
            self.histogramByExtensionChart = $("#histogramByExtensionChart").kendoChart({
                axisDefaults: self.axisDefaults,
                legend: {
                    visible: true,
                    position: "top",
                    labels: {
                        font: "12px Roboto,sans-serif",
                        color: "#777"
                    },
                    /*markers: {
                        type: "circle",
                        width: 12,
                        height: 12
                    }*/
                },
                seriesDefaults: {
                    type: "column",
                    stack: true,
                    overlay: self.seriesDefaults.overlay
                },
                series: series,
                dataSource: {
                    data: []
                },
                valueAxis: [{
                        labels: {
                            format: "N0",
                            template: function (e) {
                                if (self.chartFilterType() === 5 || self.chartFilterType() === 4) {
                                    return window["global"].dateUtils.secondsToDuration(e.value);
                                }
                                return kendo.toString(e.value, "N0");
                            }
                        },
                        line: {
                            visible: false
                        },
                        axisCrossingValue: 0
                    }],
                categoryAxis: [{
                        field: "Extension",
                        line: {
                            visible: false
                        },
                        labels: {
                            rotation: "auto",
                            //cursor: "pointer",
                            template: function (e) {
                                var name = self.getExtensionName(e.value);
                                return name || e.value;
                            }
                        }
                    }],
                tooltip: {
                    visible: true,
                    font: self.axisDefaults.title.font,
                    color: "white",
                    template: function (e) {
                        var value = kendo.toString(e.value, "N0");
                        var name = self.getExtensionName(e.category);
                        if (self.chartFilterType() === 5 || self.chartFilterType() === 4) {
                            value = window["global"].dateUtils.secondsToDuration(e.value);
                        }
                        return "".concat(name, " (").concat(e.category, ") \u2013 ").concat(e.series.name, " ").concat(value);
                    }
                },
                /*chartArea: {
                    height: 250
                },*/
                dataBound: function (e) {
                    /*var series = e.sender.options.series;
                    for (var i = 0; i < series.length; i++) {
                        series[i].name = "Calls";
                        if (self.chartFilterType() === 3) {
                            series[i].name = "Users";
                        }
                        if (self.chartFilterType() === 4) {
                            series[i].name = "Call Duration";
                        }
                        if (self.chartFilterType() === 5) {
                            series[i].name = "Hold Duration";
                        }
                    }*/
                },
                zoomable: {
                    mousewheel: false
                },
                transitions: false,
                drag: function (e) {
                    var chart = e.sender;
                    var ds = chart.dataSource;
                    var delta = Math.round(e.originalEvent.x.initialDelta / DRAG_THR);
                    if (delta !== 0) {
                        self.newStart = Math.max(0, self.viewStart - delta);
                        self.newStart = Math.min(self.totalExtensionRecords - self.viewSize, self.newStart);
                        if (self.newStart < 0) {
                            self.newStart = 0;
                        }
                        log.log("new start: ".concat(self.newStart, ", viewSize: ").concat(self.viewSize, ", total: ").concat(self.totalExtensionRecords));
                        self.histogramSelectionByExtensionChart.setOptions({
                            categoryAxis: [
                                {
                                    select: {
                                        from: self.newStart,
                                        to: self.newStart + self.viewSize
                                    },
                                    majorGridLines: {
                                        visible: false
                                    }
                                }
                            ]
                        });
                        ds.query({
                            skip: self.newStart,
                            page: 0,
                            pageSize: self.viewSize
                        });
                    }
                },
                dragEnd: function () {
                    self.viewStart = self.newStart;
                    log.log("new start: ".concat(self.newStart, ", viewSize: ").concat(self.viewSize));
                }
            }).data("kendoChart");
        };
        GroupsDashboard.prototype.initHistogramSelectionChart = function () {
            var self = this;
            var series = [
                {
                    type: "column",
                    field: "TotalCalls",
                    categoryField: "Extension",
                    style: "smooth",
                    name: "Group Handled Calls",
                    visible: true,
                    color: "#66bb6a",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    field: "AnsweredByUser",
                    categoryField: "Extension",
                    style: "smooth",
                    name: "Group Answered Calls",
                    visible: true,
                    color: "#29b6f6",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    field: "MissedCalls",
                    categoryField: "Extension",
                    style: "smooth",
                    name: "Missed By Groups",
                    visible: true,
                    color: "#ef5350",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    field: "TotalUsers",
                    categoryField: "Extension",
                    style: "smooth",
                    name: "Total Users",
                    visible: true,
                    color: "#ffa726",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }
            ];
            self.histogramSelectionByExtensionChart = $("#histogramSelectionByExtensionChart").kendoChart({
                axisDefaults: $.extend({}, self.axisDefaults, { labels: { visible: false } }),
                legend: {
                    visible: false,
                    labels: self.axisDefaults.title
                },
                seriesDefaults: {
                    type: "column",
                    stack: true,
                    overlay: self.seriesDefaults.overlay
                },
                series: series,
                dataSource: {
                    data: []
                },
                valueAxis: [{
                        labels: {
                            font: self.axisDefaults.labels.font,
                            color: self.axisDefaults.labels.color,
                            visible: true,
                            format: "N0",
                            template: function (e) {
                                if (e.value === 0) {
                                    if (self.chartFilterType() === 5 || self.chartFilterType() === 5) {
                                        return window["global"].dateUtils.secondsToDuration(e.value);
                                    }
                                    return kendo.toString(e.value, "N0");
                                }
                                return "";
                            }
                        },
                        majorGridLines: {
                            visible: false
                        }
                    }],
                categoryAxis: [{
                        field: "Extension",
                        labels: {
                            visible: false
                        },
                        select: {
                            from: self.viewStart,
                            to: self.viewSize,
                            //mousewheel: false
                        },
                        majorGridLines: {
                            visible: false
                        }
                    }],
                chartArea: {
                    height: 55
                },
                transitions: false,
                zoomable: {
                    mousewheel: false
                },
                select: function (e) {
                    log.log("Select: ".concat(e.from, " - ").concat(e.to));
                    var ds = self.histogramByExtensionChart.dataSource;
                    self.newStart = e.from;
                    self.viewSize = e.to - e.from;
                    ds.query({
                        skip: self.newStart,
                        page: 0,
                        pageSize: self.viewSize
                    });
                }
            }).data("kendoChart");
        };
        GroupsDashboard.prototype.initPieChart = function () {
            var self = this;
            self.donutByExtensionChart = $("#donutByExtensionChart").kendoChart({
                axisDefaults: self.axisDefaults,
                legend: {
                    visible: false,
                    position: "right",
                    orientation: "horizontal",
                    width: 100,
                    labels: self.axisDefaults.title
                },
                seriesDefaults: {
                    type: "pie",
                    //startAngle: 150,
                    overlay: self.seriesDefaults.overlay
                },
                series: [{
                        name: "Calls",
                        field: "calls",
                        colorField: "color",
                        categoryField: "extention",
                        //padding: 0,
                        border: {
                            width: 2,
                            color: "white",
                            dashType: "solid"
                        }
                    }],
                dataSource: {
                    data: []
                },
                valueAxis: [{
                        line: {
                            visible: false
                        },
                        axisCrossingValue: 0
                    }],
                tooltip: {
                    visible: true,
                    template: function (e) {
                        var value = kendo.toString(e.value, "N0");
                        var name = self.getExtensionName(e.category);
                        var what = "calls";
                        if (self.chartFilterType() === 5 || self.chartFilterType() === 4) {
                            value = window["global"].dateUtils.secondsToDuration(e.value);
                            what = "duration";
                        }
                        return "".concat(name, " (").concat(e.category, ") \u2013 ").concat(value, " ").concat(what);
                    }
                },
                dataBound: function (e) {
                    var data = e.sender.dataSource.view();
                    self.filteredChartDataByGroup(data.toJSON());
                }
            }).data("kendoChart");
        };
        GroupsDashboard.prototype.initPieSelectionChart = function () {
            var self = this;
            self.pieSelectionByExtensionChart = $("#donutSelectionByExtensionChart").kendoChart({
                axisDefaults: self.axisDefaults,
                legend: {
                    visible: false,
                    labels: self.axisDefaults.title
                },
                seriesDefaults: {
                    type: "column",
                    overlay: self.seriesDefaults.overlay
                },
                series: [{
                        name: "Answered Calls",
                        field: "calls",
                        colorField: "color"
                    }],
                dataSource: {
                    data: []
                },
                valueAxis: [{
                        labels: {
                            format: "N0",
                            template: function (e) {
                                if (e.value === 0) {
                                    if (self.chartFilterType() === 5 || self.chartFilterType() === 5) {
                                        return window["global"].dateUtils.secondsToDuration(e.value);
                                    }
                                    return kendo.toString(e.value, "N0");
                                }
                                return "";
                            }
                        },
                        majorGridLines: {
                            visible: false
                        }
                    }],
                categoryAxis: [{
                        field: "extention",
                        labels: {
                            visible: false
                        },
                        select: {
                            from: self.pieViewStart,
                            to: self.pieViewSize,
                            //mousewheel: false
                        },
                        majorGridLines: {
                            visible: false
                        }
                    }],
                chartArea: {
                    height: 55
                },
                transitions: false,
                zoomable: {
                    mousewheel: false
                },
                select: function (e) {
                    log.log("Select: ".concat(e.from, " - ").concat(e.to));
                    var ds = self.donutByExtensionChart.dataSource;
                    self.pieNewStart = e.from;
                    self.pieViewSize = e.to - e.from;
                    ds.query({
                        skip: self.pieNewStart,
                        page: 0,
                        pageSize: self.pieViewSize
                    });
                }
            }).data("kendoChart");
        };
        GroupsDashboard.prototype.getChartDataByGroup = function (type) {
            var self = this;
            self.chartFilterType(type);
            switch (type) {
                case 0:
                    self.chartFilterTypeName("Handled Calls");
                    break;
                case 1:
                    self.chartFilterTypeName("Answered Calls");
                    break;
                case 2:
                    self.chartFilterTypeName("Missed Calls");
                    break;
                case 3:
                    self.chartFilterTypeName("Active Agents");
                    break;
                case 4:
                    self.chartFilterTypeName("Total Calls Duration");
                    break;
                default:
                    self.chartFilterTypeName("Total Calls");
                    break;
            }
            var mappedData = [];
            var mappedDataStacked = [];
            ko.utils.arrayForEach(self.chartDataByGroup()
                .sort(function (left, right) {
                if (type === 0 || type === -1) {
                    return left.TotalCalls === right.TotalCalls ? 0 : (left.TotalCalls > right.TotalCalls ? -1 : 1);
                }
                if (type === 1) {
                    return left.AnsweredByUser === right.AnsweredByUser ? 0 : (left.AnsweredByUser > right.AnsweredByUser ? -1 : 1);
                }
                if (type === 2) {
                    return left.MissedCalls === right.MissedCalls ? 0 : (left.MissedCalls > right.MissedCalls ? -1 : 1);
                }
                if (type === 3) {
                    return left.TotalUsers === right.TotalUsers ? 0 : (left.TotalUsers > right.TotalUsers ? -1 : 1);
                }
                if (type === 4) {
                    return left.TotalCallDuration === right.TotalCallDuration ? 0 : (left.TotalCallDuration > right.TotalCallDuration ? -1 : 1);
                }
                return left.TotalCalls === right.TotalCalls ? 0 : (left.TotalCalls > right.TotalCalls ? -1 : 1);
            }), function (item) {
                var newStackedObject = {
                    Extension: item.Id,
                    TotalCalls: item.TotalCalls,
                    AnsweredByUser: item.AnsweredByUser,
                    MissedCalls: item.MissedCalls,
                    TotalUsers: item.TotalUsers
                };
                mappedDataStacked.push(newStackedObject);
                var newObject = {
                    extention: item.Id,
                    calls: type === 0 || type === -1 ? item.TotalCalls
                        : type === 1 ? item.AnsweredByUser
                            : type === 2 ? item.MissedCalls
                                : type === 3 ? item.TotalUsers
                                    : type === 4 ? item.TotalCallDuration / 1000 : item.TotalCalls,
                    color: self.getRandomColor()
                };
                if (item.Id) {
                    switch (type) {
                        case -1:
                            if (item.TotalCalls > 0)
                                mappedData.push(newObject);
                            break;
                        case 0:
                            if (item.TotalCalls > 0)
                                mappedData.push(newObject);
                            break;
                        case 1:
                            if (item.AnsweredByUser > 0)
                                mappedData.push(newObject);
                            break;
                        case 2:
                            if (item.MissedCalls > 0)
                                mappedData.push(newObject);
                            break;
                        case 3:
                            if (item.TotalUsers > 0)
                                mappedData.push(newObject);
                            break;
                        case 4:
                            if (item.TotalCallDuration > 0)
                                mappedData.push(newObject);
                            break;
                        default:
                    }
                }
            });
            self.totalExtensionRecords = mappedData.length;
            self.viewStart = 0;
            self.viewSize = 30;
            self.pieViewStart = 0;
            self.pieViewSize = 30;
            var stackedDatasource = new kendo.data.DataSource({
                data: mappedDataStacked,
                pageSize: self.viewSize,
                page: 0
            });
            var zoomablePieDatasource = new kendo.data.DataSource({
                data: mappedData,
                pageSize: self.pieViewSize,
                page: 0
            });
            self.histogramSelectionByExtensionChart.setOptions({
                categoryAxis: [
                    {
                        select: {
                            from: self.viewStart,
                            to: self.viewSize,
                            mousewheel: false
                        },
                        majorGridLines: {
                            visible: false
                        }
                    }
                ]
            });
            self.pieSelectionByExtensionChart.setOptions({
                categoryAxis: [
                    {
                        select: {
                            from: self.pieViewStart,
                            to: self.pieViewSize,
                            mousewheel: false
                        },
                        majorGridLines: {
                            visible: false
                        }
                    }
                ]
            });
            self.histogramByExtensionChart.setDataSource(stackedDatasource);
            self.pieSelectionByExtensionChart.setDataSource(zoomablePieDatasource);
            self.donutByExtensionChart.setDataSource(zoomablePieDatasource);
            self.histogramSelectionByExtensionChart.setDataSource(new kendo.data.DataSource({
                data: mappedDataStacked
            }));
            self.pieSelectionByExtensionChart.setDataSource(new kendo.data.DataSource({
                data: mappedData
            }));
            if (!self.firstTimeLoad()) {
                self.updateTimeSeriesChart(self.lineByTimeChart);
                self.updateTimeSeriesChart(self.histogramByTimeChart);
                self.updateChartVisibility(self.histogramByExtensionChart);
                self.updateChartVisibility(self.histogramSelectionByExtensionChart);
            }
            self.mainTable.refresh();
        };
        GroupsDashboard.prototype.updateTimeSeriesChart = function (chart) {
            var self = this;
            var i;
            var timeSeries = ko.utils.arrayFilter(chart.options.series, function (item) {
                return item.axis !== "_navigator";
            });
            var navigatorSeries = ko.utils.arrayFilter(chart.options.series, function (item) {
                return item.axis === "_navigator";
            });
            for (i = 0; i < timeSeries.length; i++) {
                var item = timeSeries[i];
                item.visible = false;
                if (i === self.chartFilterType() || (self.chartFilterType() === -1 && i !== 4)) {
                    item.visible = true;
                }
            }
            for (i = 0; i < navigatorSeries.length; i++) {
                var item1 = navigatorSeries[i];
                item1.visible = false;
                if (i === self.chartFilterType() || (self.chartFilterType() === -1 && i !== 4)) {
                    item1.visible = true;
                }
            }
            chart.redraw();
        };
        GroupsDashboard.prototype.updateChartVisibility = function (chart) {
            var self = this;
            var i;
            var timeSeries = ko.utils.arrayFilter(chart.options.series, function (item) {
                return item.axis !== "_navigator";
            });
            for (i = 0; i < timeSeries.length; i++) {
                var item = timeSeries[i];
                item.visible = false;
                if (i === self.chartFilterType() || (self.chartFilterType() === -1 && i !== 4)) {
                    item.visible = true;
                }
            }
            chart.redraw();
        };
        GroupsDashboard.prototype.initLineByTimeChart = function () {
            var self = this;
            var series = [
                {
                    type: "line",
                    aggregate: "sum",
                    field: "TotalCalls",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Group Handled Calls",
                    visible: true,
                    color: "#66bb6a",
                    markers: {
                        visible: false
                    }
                }, {
                    type: "line",
                    aggregate: "sum",
                    field: "AnsweredByUser",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Group Answered Calls",
                    visible: true,
                    color: "#29b6f6",
                    markers: {
                        visible: false
                    }
                }, {
                    type: "line",
                    aggregate: "sum",
                    field: "MissedCalls",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Missed By Groups",
                    visible: true,
                    color: "#ef5350",
                    markers: {
                        visible: false
                    }
                }, {
                    type: "line",
                    aggregate: "sum",
                    field: "TotalUsers",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Total Users",
                    visible: true,
                    color: "#ffa726",
                    markers: {
                        visible: false
                    }
                }, {
                    type: "line",
                    aggregate: "sum",
                    field: "TotalCallDuration",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Total Calls Duration",
                    visible: false,
                    color: "#009688",
                    labels: {
                        template: kendo.template("#:  #")
                    },
                    markers: {
                        visible: false
                    }
                }
            ];
            self.lineByTimeChart = $("#lineByTimeChart").kendoStockChart({
                dataSource: {
                    data: [],
                    schema: {
                        model: {
                            fields: {
                                Date: { type: "time" },
                                AnsweredCalls: { type: "number" },
                                AnsweredByMailbox: { type: "number" }
                            }
                        },
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    serverPaging: false
                },
                axisDefaults: self.axisDefaults,
                seriesDefaults: self.seriesDefaults,
                legend: {
                    visible: true,
                    position: "top",
                    labels: {
                        font: '12px Roboto,sans-serif',
                        color: "#777"
                    },
                    /*markers: {
                        type: "circle",
                        width: 12,
                        height: 12,
                    }*/
                },
                dataBound: function (e) {
                    /*setTimeout(() => {
                        self.changeChartRange(self.currentChartRange());
                    }, 300);*/
                },
                dateField: "Date",
                series: series,
                categoryAxis: [{
                        baseUnitStep: "auto",
                        baseUnit: "fit",
                        /*maxDateGroups: 30,*/
                        autoBaseUnitSteps: {
                            days: [1, 2, 3],
                            hours: [1, 2, 3],
                            months: [1, 2, 3],
                            weeks: [1, 2],
                            minutes: [0]
                        },
                        majorGridLines: {
                            visible: true
                        },
                        majorTicks: {
                            visible: true
                        },
                        crosshair: {
                            visible: true
                        },
                        labels: {
                        //rotation: "auto"
                        }
                    }],
                valueAxis: [{
                        title: {
                        //text: "Total Calls"
                        },
                        majorGridLines: {
                            visible: true
                        },
                        visible: true,
                        labels: {
                            format: "N0",
                            template: function (e) {
                                if (self.chartFilterType() === 4) {
                                    return window["global"].dateUtils.secondsToDuration(e.value / 1000);
                                }
                                return kendo.toString(e.value, "N0");
                            }
                        }
                    }],
                tooltip: {
                    visible: true,
                    shared: true,
                    format: "N0",
                    sharedTemplate: function (e) {
                        var html = "<div><b>".concat(kendo.toString(e.category, "g"), "</b></div>");
                        for (var i = 0; i < e.points.length; i++) {
                            var value = self.chartFilterType() === 4
                                ? window["global"].dateUtils.secondsToDuration(e.points[i].value / 1000)
                                : kendo.toString(e.points[i].value, "N0");
                            html += "<div>".concat(e.points[i].series.name, ": ").concat(value, "</div>");
                        }
                        return html;
                    }
                },
                navigator: {
                    pane: {
                        height: 65
                    },
                    hint: {
                        visible: false
                    },
                    select: {
                        mousewheel: false
                    },
                    series: series,
                    /*categoryAxis: [{
                        labels: {
                            rotation: "auto",
                            step: 3
                        }
                    }]*/
                }
            }).data("kendoStockChart");
        };
        GroupsDashboard.prototype.initHistogramByTimeChart = function () {
            var self = this;
            var series = [
                {
                    type: "column",
                    aggregate: "sum",
                    field: "TotalCalls",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Group Handled Calls",
                    visible: true,
                    color: "#66bb6a",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    aggregate: "sum",
                    field: "AnsweredByUser",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Group Answered Calls",
                    visible: true,
                    color: "#29b6f6",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    aggregate: "sum",
                    field: "MissedCalls",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Missed By Groups",
                    visible: true,
                    color: "#ef5350",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    aggregate: "sum",
                    field: "TotalUsers",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Total Users",
                    visible: true,
                    color: "#ffa726",
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }, {
                    type: "column",
                    aggregate: "sum",
                    field: "TotalCallDuration",
                    categoryField: "Date",
                    style: "smooth",
                    name: "Total Calls Duration",
                    visible: false,
                    color: "#009688",
                    labels: {
                        template: kendo.template("#:  #")
                    },
                    markers: {
                        visible: false
                    },
                    overlay: self.seriesDefaults.overlay
                }
            ];
            self.histogramByTimeChart = $("#histogramByTimeChart").kendoStockChart({
                dataSource: {
                    data: [],
                    schema: {
                        model: {
                            fields: {
                                Date: { type: "time" },
                                AnsweredCalls: { type: "number" },
                                AnsweredByMailbox: { type: "number" }
                            }
                        },
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    serverPaging: false
                },
                axisDefaults: self.axisDefaults,
                legend: {
                    visible: true,
                    position: "top",
                    labels: {
                        font: '12px Roboto,sans-serif',
                        color: "#777"
                    },
                    /*markers: {
                        type: "circle",
                        width: 12,
                        height: 12
                    }*/
                },
                dataBound: function (e) {
                    /*setTimeout(() => {
                        self.changeChartRange(self.currentChartRange());
                    }, 300);*/
                },
                dateField: "Date",
                series: series,
                categoryAxis: [{
                        baseUnitStep: "auto",
                        baseUnit: "fit",
                        /*maxDateGroups: 30,*/
                        autoBaseUnitSteps: {
                            days: [1, 2, 3],
                            hours: [1, 2, 3],
                            months: [1, 2, 3],
                            weeks: [1, 2],
                            minutes: [0]
                        },
                        majorGridLines: {
                            visible: true
                        },
                        majorTicks: {
                            visible: true
                        },
                        crosshair: {
                            visible: true
                        },
                        labels: {
                        //rotation: "auto"
                        }
                    }],
                valueAxis: [{
                        title: {
                        //text: "Total Calls"
                        },
                        majorGridLines: {
                            visible: true
                        },
                        visible: true,
                        labels: {
                            format: "N0",
                            template: function (e) {
                                if (self.chartFilterType() === 4) {
                                    return window["global"].dateUtils.secondsToDuration(e.value / 1000);
                                }
                                return kendo.toString(e.value, "N0");
                            }
                        }
                    }],
                tooltip: {
                    visible: true,
                    shared: true,
                    format: "N0",
                    sharedTemplate: function (e) {
                        var html = "<div><b>".concat(kendo.toString(e.category, "g"), "</b></div>");
                        for (var i = 0; i < e.points.length; i++) {
                            var value = self.chartFilterType() === 4
                                ? window["global"].dateUtils.secondsToDuration(e.points[i].value / 1000)
                                : kendo.toString(e.points[i].value, "N0");
                            html += "<div>".concat(e.points[i].series.name, ": ").concat(value, "</div>");
                        }
                        return html;
                    }
                },
                navigator: {
                    pane: {
                        height: 65
                    },
                    hint: {
                        visible: false
                    },
                    series: series,
                    /*categoryAxis: [{
                        labels: {
                            rotation: "auto",
                            step: 3
                        }
                    }]*/
                }
            }).data("kendoStockChart");
        };
        GroupsDashboard.prototype.getDomainAccounts = function (domain) {
            var self = this;
            tools.ajaxPost({
                url: "/Reports/GetDomainAccountsData",
                data: { domain: domain },
                success: function (data) {
                    if (data.Data) {
                        self.domainGroups(data.Data.filter(function (item) {
                            return item.Type === "acds";
                        }));
                    }
                }
            });
        };
        GroupsDashboard.prototype.resizeChart = function () {
            setTimeout(function () {
                kendo.resize($("#histogramByExtensionChart"), true);
                kendo.resize($("#histogramSelectionByExtensionChart"), true);
                kendo.resize($("#donutByExtensionChart"), true);
                kendo.resize($("#donutSelectionByExtensionChart"), true);
                kendo.resize($("#lineByTimeChart"), true);
                kendo.resize($("#histogramByTimeChart"), true);
            }, 100);
        };
        GroupsDashboard.prototype.openFilterDialog = function () {
            $("#advancedFilterDialog").modal("show");
            log.log("advancedFilterDialog clicked");
        };
        GroupsDashboard.prototype.filterClicked = function () {
            var self = this;
            var groups = $("input:checkbox[name=filterByGroup]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedDomainGroups(groups);
            $("#advancedFilterDialog input[name='showByType']").each(function (index, element) {
                var isChecked = $(element).is(":checked");
                var value = $(element).val();
                var selector = ".stats-item[data-type='".concat(value, "']");
                if (isChecked) {
                    $(selector).show();
                }
                else {
                    $(selector).hide();
                }
            });
            $("#advancedFilterDialog input[name='showChart']").each(function (index, element) {
                var isChecked = $(element).is(":checked");
                var value = $(element).val();
                var selector = "#chart".concat(value);
                if (isChecked) {
                    $(selector).show();
                }
                else {
                    $(selector).hide();
                }
            });
            $("#advancedFilterDialog").modal("hide");
            self.applyFilter();
        };
        GroupsDashboard.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            ko.utils.arrayForEach(columns, function (column) {
                if (!column.hidden) {
                    self.desktopColumns.push(column);
                }
            });
            self.mobileColumn = {
                field: "mobileField",
                title: "Call list",
                sortable: false,
                hidden: true,
                template: kendo.template($("#mobile-list-template").html())
            };
            columns.push(self.mobileColumn);
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetCallLogsData",
                            type: "POST",
                            data: function () {
                                self.filterInProgress(true);
                                var data = {};
                                data.fromdate = DateUtils.toIsoString(self.filterCdrSummaryReportByStartDate());
                                data.todate = DateUtils.toIsoString(self.filterCdrSummaryReportByEndDate());
                                if (self.filterCdrByDomain()) {
                                    data.domain = self.filterCdrByDomain();
                                }
                                data.periodType = self.dateRangeType();
                                data.statuses = "";
                                data.callTypes = "Group";
                                data.groups = self.selectedDomainGroups().join(",");
                                data.extensions = "";
                                switch (self.chartFilterType()) {
                                    case 0:
                                        break;
                                    case 1:
                                        data.statuses = "Answered";
                                        break;
                                    case 2:
                                        data.statuses = "Missed,Mailbox";
                                        break;
                                    case 3:
                                        data.statuses = "Answered";
                                        break;
                                    case 4:
                                        break;
                                    default:
                                }
                                data.totalTimeFrom = "";
                                data.totalTimeTo = "";
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    serverAggregates: true,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    sort: { field: "Start", dir: "desc" }
                },
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    height: "400px",
                    dataBound: function () {
                        //self.filterInProgress(false);
                        //$("button[data-action='applyFilter']").button("reset");
                    },
                    detailTemplate: kendo.template($("#call-details-template").html())
                },
                enableExport: {
                    entityName: "CallDetailsReport",
                    title: "Call Logs",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                autoHeight: {
                    totalOffset: 46 + 56 + 55 - 25
                },
                enableStickyHeader: false,
                gridId: "tblCallLogs",
                showPagerOnTop: false,
                customLoading: true,
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            var resizeEvent;
            $(window).resize(function () {
                if (resizeEvent) {
                    clearTimeout(resizeEvent);
                }
                resizeEvent = setTimeout(function () {
                    self.updateCulumnsVisibilityOnResize();
                }, 100);
            });
            self.updateCulumnsVisibilityOnResize();
            $("#tblCallLogs").on("click", ".k-master-row", function (event) {
                var row = $(event.currentTarget).closest("tr");
                self.collapseAllKendoGridDetailRows('tblCallLogs', row);
                setTimeout(function () {
                    var link = row.find("td.k-hierarchy-cell .k-icon");
                    link.click();
                });
            }).on("click", ".toggle-flow-details", function (event) {
                var row = $(event.currentTarget).closest(".mobile-list");
                var details = $('.flow-details', row);
                details.toggle();
            });
        };
        GroupsDashboard.prototype.updateCulumnsVisibilityOnResize = function () {
            var self = this;
            var grid = self.mainTable.getGridData();
            var currentView = window.innerWidth < 1150;
            if (currentView === self.mobileView) {
                return;
            }
            self.mobileView = currentView;
            if (self.mobileView) {
                ko.utils.arrayForEach(self.desktopColumns, function (column) {
                    grid.hideColumn(column.field);
                });
                //grid.hideColumn(0);
                grid.showColumn(self.mobileColumn.field);
                grid.setOptions({
                    detailTemplate: null
                });
            }
            else {
                //grid.showColumn(0);
                grid.hideColumn(self.mobileColumn.field);
                ko.utils.arrayForEach(self.desktopColumns, function (column) {
                    grid.showColumn(column.field);
                });
                grid.setOptions({
                    detailTemplate: kendo.template($("#call-details-template").html())
                });
            }
        };
        GroupsDashboard.prototype.collapseAllKendoGridDetailRows = function (prmGridId, rowToIgnore) {
            //Get a collection of all rows in the grid
            var grid = $('#' + prmGridId).data('kendoGrid');
            var allMasterRows = grid.tbody.find('>tr.k-master-row');
            //Loop through each row, if a row has a detail row following it then collapse that master row
            for (var i = 0; i < allMasterRows.length; i++) {
                var row = allMasterRows.eq(i);
                if (row.is(rowToIgnore)) {
                    continue;
                }
                if (row.next('tr.k-detail-row').length > 0) {
                    grid.collapseRow(row);
                }
            }
        };
        GroupsDashboard.prototype.getGrandTotals = function () {
            var self = this;
            var data = {
                domain: self.filterCdrByDomain(),
                fromdate: DateUtils.toIsoString(self.filterCdrSummaryReportByStartDate()),
                todate: DateUtils.toIsoString(self.filterCdrSummaryReportByEndDate()),
                periodType: self.dateRangeType(),
                callTypes: "",
                statuses: "",
                groups: self.selectedDomainGroups().join(",")
            };
            tools.ajaxPost({
                url: "/Reports/GetGroupsTotals",
                data: data,
                success: function (data) {
                    if (data.Success) {
                        self.grandTotalsData(data.Data.GrandTotals[0] || {
                            TotalCalls: 0,
                            MissedCalls: 0,
                            AnsweredByUser: 0,
                            TotalUsers: 0,
                            TotalHoldDuration: 0,
                            TotalCallDuration: 0
                        });
                        self.chartDataByGroup(data.Data.TotalsByGroup);
                        if (self.lineByTimeChart) {
                            self.lineByTimeChart.navigator.options.select = {}; //reset selection
                            self.lineByTimeChart.dataSource.data(data.Data.TotalsByTime);
                        }
                        if (self.histogramByTimeChart) {
                            self.histogramByTimeChart.navigator.options.select = {}; //reset selection
                            self.histogramByTimeChart.dataSource.data(data.Data.TotalsByTime);
                        }
                        self.getChartDataByGroup(self.chartFilterType());
                        self.runCountTo();
                    }
                }
            }).always(function () {
                $(".loader-container").hide();
            });
        };
        GroupsDashboard.prototype.applyFilter = function () {
            _super.prototype.applyFilter.call(this);
            var self = this;
            if (self.reloadDataTimer > 0) {
                clearTimeout(self.reloadDataTimer);
            }
            self.reloadDataTimer = setTimeout(function () {
                $(".loader-container").show();
                self.getGrandTotals();
            }, 300);
        };
        GroupsDashboard.prototype.clearFilter = function () {
            _super.prototype.clearFilter.call(this);
            var self = this;
            $("#domainsList").data("kendoDropDownList").value(self.domainList[0]);
            self.filterCdrByDomain(self.domainList[0]);
            self.filterCdrSummaryReportByStartDate(DateUtils.today());
            self.filterCdrSummaryReportByEndDate(DateUtils.today());
        };
        GroupsDashboard.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.mainTable.exportToMaterial();
            }
        };
        return GroupsDashboard;
    }(ReportBase));
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/GroupsDashboard")) {
            log.log("Initialize GroupsDashboard list");
            $(function () {
                (new GroupsDashboard()).init();
            });
        }
    }, 0);
    return GroupsDashboard;
});
//# sourceMappingURL=groupsDashboard.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/groupsDashboard.js
// module id = 252
// module chunks = 2